import shortid from "shortid";
import {
  calcularPercentualComissaoVendedor,
  calcularPrecoCompra,
  calcularPrecoCusto,
  calcularValorComissaoVendedor,
  validarLucro,
  validarPrecoVenda,
} from "../addProduto";
import { ProdutoFornecedores } from "./index";

export class Produto {
  id = null;
  createdAt = null;
  updatedAt = null;
  insertUserId = null;
  updateUserId = null;
  ativado = null;
  imagens = null;
  codigo = null;
  codigoBarra = null;
  grupoProdutoId = null;
  grupoProdutoNome = null;
  subgrupoProdutoId = null;
  subgrupoProdutoNome = null;
  familiaProdutoId = null;
  familiaProdutoNome = null;
  subfamiliaProdutoId = null;
  subfamiliaProdutoNome = null;
  tipo = null;
  descricao = null;
  produtoInformacaoId = null;
  unidadeComercialCompraId = null;
  unidadeComercialCompraNome = null;
  unidadeComercialVendaId = null;
  unidadeComercialVendaNome = null;
  conversorEntrada = null;
  estoqueAtual = null;
  fracionavel = null;
  lerPesoPorBalanca = null;
  precoCompra = null;
  precoCusto = null;
  precoMedio = null;
  lucroDesejado = null;
  precoVenda = null;
  comissao = null;
  grupoTributacaoId = null;
  grupoTributacaoNome = null;
  tipoItemId = null;
  tipoItemNome = null;
  ncmId = null;
  ncmCodigo = null;
  cestId = null;
  cestCodigo = null;
  origemMercadoriaId = null;
  origemMercadoriaNome = null;
  aliquotaMva = null;
  informacaoAdicionalNfe = null;
  informacaoComplementar = null;
  produtosSimilaresIds = null;
  fornecedores = null;
  produtosKitIds = null;
  camposPersonalizados = null;
  tagsProdutos = null;
  produtosGrade = null;
  gradeId = null;
  modeloGradeId = null;
  eixoX = null;
  eixoY = null;
  marcaId = null;
  marcaNome = null;
  colecaoId = null;
  colecaoNome = null;
  estoqueMinimo = null;
  altura = null;
  largura = null;
  comprimento = null;
  peso = null;
  hubVendas = false;
  gtin = null;
  embalagem = null;
  isMedicamento = false;
  isCombustivel = false;
  dataValidade = null;
  dataFabricacao = null;
  precoMaxConsumo = null;
  numLote = null;
  qtdLote = null;
  agregado = null;
  prodAnvisa = null;
  motivoIsencao = null;
  anpCodigo = null;
  anpDescricao = null;
  unidadeTributavelId = null;
  unidadeTributavelNome = null;
  qtdTributavel = null;
  glp = null;
  gasNaturalNacional = null;
  gasNaturalImp = null;
  valorPartida = null;
  codif = null;
  qtdCombTempAmbiente = null;
  bcCide = null;
  aliquotaCide = null;
  valorCide = null;
  indicadorImportacao = null;
  ufOrigem = null;
  percentualUf = null;
  aplicacoes = null;
  parametrosAliquotas = null;
  produtoMedComb = null;
  produtoInformacaoId = null;
  envioKitItensFiscal = null;
  pesoLiquido = null;
  referenciaPeca = null;
  enderecoEstoqueId = null;
  dataRevisaoFiscal = null;

  constructor(produto, id) {
    if (id) {
      this.id = id;
    }
    this.createdAt = produto.createdAt;
    this.updatedAt = produto.updatedAt;
    this.insertUserId = produto.insertUserId;
    this.updateUserId = produto.updateUserId;
    this.ativado = produto.ativado;
    this.imagens = produto.imagens;
    this.codigo = produto.codigo;
    this.codigoBarra = produto?.codigoBarra?.length
      ? produto.codigoBarra.replace(/[^\w\s]/gi, "")
      : null;
    this.gtin = produto?.gtin?.length
      ? produto.gtin.replace(/[^\w\s]/gi, "")
      : null;
    this.produtoInformacaoId = produto.produtoInformacaoId
      ? produto.produtoInformacaoId
      : shortid.generate();
    this.grupoProdutoId = produto.grupoProdutoId;
    this.subgrupoProdutoId = produto.subgrupoProdutoId;
    this.familiaProdutoId = produto.familiaProdutoId;
    this.subfamiliaProdutoId = produto.subfamiliaProdutoId;
    this.tipo = produto.tipo;
    this.descricao = produto.descricao;
    this.unidadeComercialCompraId = produto.unidadeComercialCompraId;
    this.unidadeComercialVendaId = produto.unidadeComercialVendaId;
    this.conversorEntrada = produto.conversorEntrada;
    this.estoqueAtual = produto.estoqueAtual;
    this.fracionavel = produto.fracionavel;
    this.lerPesoPorBalanca = produto.lerPesoPorBalanca;
    this.precoCompra = isNaN(produto.precoCompra) ? null : produto.precoCompra;
    this.precoCusto = isNaN(produto.precoCusto) ? null : produto.precoCusto;
    this.precoMedio = isNaN(produto.precoMedio)
      ? null
      : produto.precoMedio || 0;
    this.eixoX = produto.eixoX;
    this.eixoY = produto.eixoY;
    this.precoVenda = isNaN(produto.precoVenda) ? null : produto.precoVenda;
    this.lucroDesejado = produto.lucroDesejado;
    this.comissao = produto.comissao;
    this.precoStandard = produto.precoStandard;
    this.grupoTributacaoId = produto.grupoTributacaoId;
    this.tipoItemId = produto.tipoItemId;
    this.ncmId = produto.ncmId;
    this.ncmCodigo = produto.ncmCodigo;
    this.cestId = produto.cestId;
    this.marcaId = produto.marcaId;
    this.colecaoId = produto.colecaoId;
    this.origemMercadoriaId = produto.origemMercadoriaId;
    this.aliquotaMva = produto.aliquotaMva;
    this.tagsProdutos = produto.tagsProdutos;
    this.informacaoAdicionalNfe = produto.informacaoAdicionalNfe;
    this.informacaoComplementar = produto.informacaoComplementar;
    this.produtosSimilaresIds = produto.produtosSimilaresIds;
    this.estoqueMinimo = produto.estoqueMinimo;
    this.altura = produto.altura;
    this.largura = produto.largura;
    this.peso = produto.peso;
    this.hubVendas = produto.hubVendas;
    this.embalagem = produto.embalagem;
    this.isCombustivel = produto.isCombustivel ?? false;
    this.comprimento = produto.comprimento;
    this.fornecedores = produto.fornecedores?.length
      ? produto.fornecedores.map(
          (fornecedor) => new ProdutoFornecedores(fornecedor),
        )
      : [];
    this.produtosKitIds = produto.produtosKitIds;
    this.camposPersonalizados = produto.camposPersonalizados;
    this.gradeId = produto.gradeId;
    this.modeloGradeId = produto.modeloGradeId;
    this.produtoInformacaoId = produto.produtoInformacaoId;
    this.produtosGrade = produto.produtosGrade?.length
      ? produto.produtosGrade.map((produtoGrade) => {
          // eslint-disable-next-line no-unused-vars
          const { produtosGrade: _, ...dadosBase } = this;
          const dadosCompletos = {
            ...dadosBase,
            ...produtoGrade,
            produtoInformacaoId: produtoGrade.informacao?.id,
            tipo: "grade",
          };
          return new Produto(dadosCompletos, produtoGrade?.id);
        })
      : [];
    this.dataValidade = produto.dataValidade;
    this.dataFabricacao = produto.dataFabricacao;
    this.precoMaxConsumo = produto.precoMaxConsumo;
    this.numLote = produto.numLote;
    this.qtdLote = produto.qtdLote;
    this.agregado = produto.agregado;
    this.prodAnvisa = produto.prodAnvisa;
    this.motivoIsencao = produto.motivoIsencao;
    this.anpCodigo = produto.anpCodigo;
    this.anpDescricao = produto.anpDescricao;
    this.unidadeTributavelId = produto.unidadeTributavelId;
    this.qtdTributavel = produto.qtdTributavel;
    this.glp = produto.glp;
    this.gasNaturalNacional = produto.gasNaturalNacional;
    this.gasNaturalImp = produto.gasNaturalImp;
    this.valorPartida = produto.valorPartida;
    this.codif = produto.codif;
    this.qtdCombTempAmbiente = produto.qtdCombTempAmbiente;
    this.bcCide = produto.bcCide;
    this.aliquotaCide = produto.aliquotaCide;
    this.valorCide = produto.valorCide;
    this.indicadorImportacao = produto.indicadorImportacao;
    this.ufOrigem = produto.ufOrigem;
    this.percentualUf = produto.percentualUf;
    this.aplicacoes = produto.aplicacoes;
    this.parametrosAliquotas = produto.parametrosAliquotas;
    this.envioKitItensFiscal = produto.envioKitItensFiscal;
    this.pesoLiquido = produto.pesoLiquido;
    this.referenciaPeca = produto.referenciaPeca;
    this.enderecoEstoqueId = produto.enderecoEstoqueId;
    this.dataRevisaoFiscal = produto.dataRevisaoFiscal;
  }

  setProdutoInformacaoId(id) {
    this.produtoInformacaoId = id ? id : shortid.generate();
  }

  setImagens(imagens) {
    this.imagens = imagens;
  }

  setProdutoTipo(tipo) {
    this.tipo = tipo;
  }

  setProdutosGrade(produtosGradeList) {
    this.produtosGrade = produtosGradeList?.length
      ? produtosGradeList.map((produtoGrade) => {
          // eslint-disable-next-line no-unused-vars
          const { produtosGrade: _, ...dadosBase } = this;
          const dadosCompletos = {
            ...dadosBase,
            ...produtoGrade,
            produtoInformacaoId: produtoGrade.informacao?.id,
            tipo: "grade",
          };
          return new Produto(dadosCompletos, produtoGrade?.id);
        })
      : [];
  }

  setProdutoNcm(ncm) {
    this.ncmId = ncm.id;
    this.ncmCodigo = ncm.codigo;
  }

  setProdutoCest(cest) {
    if (cest.id) {
      this.cestId = cest.id;
    }
  }

  resetInfoFiscal() {
    this.ncmId = null;
    this.ncmCodigo = null;
    this.cestId = null;
    this.grupoTributacaoId = null;
  }

  setDescricao(descricao) {
    this.descricao = descricao;
  }

  setCodigoBarra(codigoBarra) {
    this.codigoBarra = codigoBarra?.length
      ? codigoBarra.replace(/[^\w\s]/gi, "")
      : null;
  }

  setGtin(gtin) {
    this.gtin = gtin?.length ? gtin.replace(/[^\w\s]/gi, "") : null;
  }

  setProdutoGrupoTributacao(gruposTributacaoId) {
    this.grupoTributacaoId = gruposTributacaoId;
  }

  setProdutoTags(newValue) {
    this.tagsProdutos = newValue;
  }

  setProdutoTagsIds(listTags = this.tagsProdutos) {
    if (listTags?.length) {
      this.tagsProdutos = listTags.map((item) => item.id);
    }
  }

  addProdutosKitIds(produtoKitId, quantidade) {
    if (this.produtosKitIds && this.produtosKitIds?.length) {
      this.produtosKitIds = [
        ...this.produtosKitIds,
        {
          idItemKit: produtoKitId,
          quantidade,
        },
      ];
    } else {
      this.produtosKitIds = [
        {
          idItemKit: produtoKitId,
          quantidade,
        },
      ];
    }
  }

  setProdutosKitIds(produtos) {
    this.produtosKitIds = produtos.map((prod) => ({
      idItemKit: prod.id,
      quantidade: prod.quantidade,
    }));
  }

  setFornecedores(fornecedoresList) {
    this.fornecedores = fornecedoresList?.length
      ? fornecedoresList.map(
          (fornecedor) => new ProdutoFornecedores(fornecedor),
        )
      : [];
  }

  setProdutosSimilaresIds(produtosSimilares) {
    this.produtosSimilaresIds = produtosSimilares.length
      ? produtosSimilares.map((produtoSimilar) => produtoSimilar.id)
      : [];
  }

  setHandleChangeSwitch(name, checked) {
    this[name] = checked;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;

    if (name === "conversorEntrada" && value === "") {
      this[name] = null;
    }
    if (name === "codigoBarra" && value !== "") {
      this[name] = value.replace(/[^\w\s]/gi, "");
    }
    if (name === "gtin" && value !== "") {
      this[name] = value.replace(/[^\w\s]/gi, "");
    }
  }

  setHandleChangeInputVenda = (name, value, id, configuracoes) => {
    let produtoTemp = { ...this };
    const valorMudou = this[name] !== parseFloat(value);
    if (!valorMudou) return;
    switch (name) {
      case "precoVenda":
        produtoTemp.precoVenda = value;
        Object.assign(
          produtoTemp,
          validarPrecoVenda(produtoTemp, configuracoes, this, true),
        );
        break;

      case "lucroDesejado":
        produtoTemp.lucroDesejado = value;
        produtoTemp = validarLucro(produtoTemp, configuracoes, true);
        break;

      case "precoCompra":
        produtoTemp = calcularPrecoCompra(produtoTemp, value);
        break;

      case "precoCusto":
        produtoTemp = calcularPrecoCusto(produtoTemp, value, configuracoes);
        break;

      case "valorComissaoVendedor":
        produtoTemp = calcularPercentualComissaoVendedor(produtoTemp, value);
        break;

      case "percentualComissaoVendedor":
        produtoTemp = calcularValorComissaoVendedor(produtoTemp, value);
        break;

      default:
        produtoTemp[name] = value;
        break;
    }

    if (name === "precoVenda" || name === "lucroDesejado") {
      if (id && produtoTemp.precoVenda < produtoTemp.precoCusto) {
        produtoTemp.lucroDesejado = undefined;
      }
    }

    if (name === "precoCusto" && produtoTemp.precoCusto) {
      produtoTemp = validarLucro(produtoTemp, configuracoes);
    }

    Object.assign(this, produtoTemp);
  };

  setHandleChangeAutoComplete(name, value, tabelaCest) {
    this.setNomesLogs(name, value);
    if (name == "ncmId") {
      if (tabelaCest && tabelaCest?.length) {
        this.cestId = tabelaCest[0]?.id;
        this.cestCodigo = tabelaCest[0]?.codigo;
      }
      this.ncmCodigo = value?.codigo;
    }
    this[name] = value ? value.id : null;
  }

  setNomesLogs(name, value) {
    const campos = {
      grupoProdutoId: ["grupoProdutoNome", "descricao"],
      subgrupoProdutoId: ["subgrupoProdutoNome", "descricao"],
      familiaProdutoId: ["familiaProdutoNome", "descricao"],
      subfamiliaProdutoId: ["subfamiliaProdutoNome", "descricao"],
      unidadeComercialCompraId: ["unidadeComercialCompraNome", "descricao"],
      unidadeComercialVendaId: ["unidadeComercialVendaNome", "descricao"],
      grupoTributacaoId: ["grupoTributacaoNome", "nome"],
      tipoItemId: ["tipoItemNome", "descricao"],
      cestId: ["cestCodigo", "codigo"],
      origemMercadoriaId: ["origemMercadoriaNome", "descricao"],
      marcaId: ["marcaNome", "nome"],
      colecaoId: ["colecaoNome", "descricao"],
      unidadeTributavelId: ["unidadeTributavelNome", "descricao"],
    };
    const campo = campos[name];
    if (!campo) return;
    const [propriedade, atributo] = campo;
    this[propriedade] = value?.[atributo];
  }

  setPrecos(totalCusto, totalCompra, totalVenda) {
    this.precoCusto = totalCusto;
    this.precoCompra = totalCompra;
    this.precoVenda = totalVenda;
  }

  setPrecificacao(precificacao) {
    this.precoCompra = parseFloat(precificacao.precoCompra) || 0;
    this.precoCusto = parseFloat(precificacao.precoCusto) || 0;
    this.precoMedio = parseFloat(precificacao.precoMedio) || 0;
    this.precoVenda = parseFloat(precificacao.precoVenda) || 0;
    this.precoStandard = parseFloat(precificacao.precoStandard) || 0;
    this.lucroDesejado = parseFloat(precificacao.lucroDesejado) || 0;
    this.comissao = parseFloat(precificacao.comissao) || 0;
  }

  setIsMedicamento(isMedicamento) {
    this.isMedicamento = isMedicamento;
  }

  resetInfoAnvisa() {
    this.dataValidade = null;
    this.dataFabricacao = null;
    this.precoMaxConsumo = null;
    this.numLote = null;
    this.qtdLote = null;
    this.agregado = null;
    this.prodAnvisa = null;
    this.motivoIsencao = null;
  }

  resetInfoCombustivel() {
    this.anpCodigo = null;
    this.unidadeTributavelId = null;
    this.qtdTributavel = null;
    this.glp = null;
    this.gasNaturalNacional = null;
    this.gasNaturalImp = null;
    this.valorPartida = null;
    this.codif = null;
    this.qtdCombTempAmbiente = null;
    this.bcCide = null;
    this.aliquotaCide = null;
    this.valorCide = null;
    this.indicadorImportacao = null;
    this.ufOrigem = null;
    this.percentualUf = null;
  }

  setIsCombustivel(isCombustivel) {
    this.isCombustivel = isCombustivel;
  }

  resetPercentuaisGLP() {
    this.glp = null;
    this.gasNaturalNacional = null;
    this.gasNaturalImp = null;
  }
}
